import React, { useContext } from "react";
import { CryptoContext } from "./../context/CryptoContext";
import Pagination from "./Pagination";
import { AllTable } from "./AllTable";



const TableComponent = () => {
  let { cryptoData, error } = useContext(CryptoContext);
  // console.log(cryptoData[0])
  return (
    <>
      <div className="flex flex-col mt-2 overflow-x-auto table-scroll-bar">
        {cryptoData ? (
          <AllTable data = {cryptoData} />

        ) : (!error.data && !error.search) ? (
          <div className="w-full min-h-[50vh] flex justify-center items-center">
            <div
              className="w-8 h-8 border-4 border-solid border-green rounded-full border-b-gray-200 animate-spin"
              role="status"
            />
            <span className="text-base ml-2">please wait...</span>
          </div>
        ) : error.data || error.search ? (
          <h1 className="min-h-[60vh] text-lg text-red flex items-center justify-center ">
            {error.data
              ? error.data
              : error.search
                ? error.search
                : "Something unexpected happened!"}
            {/* Here we have use multi chain conditions using ternary operator/ this is not
              covered in the video but for the example and some improvements */}
          </h1>
        ) : null}
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between mt-4 capitalize h-[2rem]">
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
    
    <Pagination />
  </div>
</div>

    </>
  );
};

export default TableComponent;
